import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Dashboard from "./pages/Dashboard";
import NewCase from "./pages/NewCase";
import CaseView from "./pages/CaseView";
import VendorPortal from "./pages/VendorPortal";
import Workspace from "./pages/Workspace";
import AppShell from "./components/AppShell";
import "@/App.css";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter basename="/estimate">
        <Routes>
          {/* Vendor Portal - No shell */}
          <Route path="/vendor/bid/:token" element={<VendorPortal />} />
          
          {/* Main App with Shell */}
          <Route path="/*" element={
            <AppShell>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/new-case" element={<NewCase />} />
                <Route path="/case/:caseId" element={<CaseView />} />
                <Route path="/workspace" element={<Workspace />} />
              </Routes>
            </AppShell>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
